var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoteCount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "red",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2429_3161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5C4.5 4.9087 5.13214 3.38258 6.25736 2.25736C7.38258 1.13214 8.9087 0.5 10.5 0.5C12.0913 0.5 13.6174 1.13214 14.7426 2.25736C15.8679 3.38258 16.5 4.9087 16.5 6.5C16.5 8.0913 15.8679 9.61742 14.7426 10.7426C13.6174 11.8679 12.0913 12.5 10.5 12.5C8.9087 12.5 7.38258 11.8679 6.25736 10.7426C5.13214 9.61742 4.5 8.0913 4.5 6.5ZM0 23.1078C0 18.4906 3.74063 14.75 8.35781 14.75H12.6422C17.2594 14.75 21 18.4906 21 23.1078C21 23.8766 20.3766 24.5 19.6078 24.5H1.39219C0.623438 24.5 0 23.8766 0 23.1078ZM28.5609 24.5H22.1016C22.3547 24.0594 22.5047 23.5484 22.5047 23V22.625C22.5047 19.7797 21.2344 17.225 19.2328 15.5094C19.3453 15.5047 19.4531 15.5 19.5656 15.5H22.4437C26.6156 15.5 30 18.8844 30 23.0609C30 23.8578 29.3531 24.5 28.5609 24.5ZM20.25 12.5C18.7969 12.5 17.4844 11.9094 16.5328 10.9578C17.4563 9.71094 18 8.16875 18 6.5C18 5.24375 17.6906 4.05781 17.1422 3.01719C18.0141 2.37969 19.0875 2 20.25 2C23.1516 2 25.5 4.34844 25.5 7.25C25.5 10.1516 23.1516 12.5 20.25 12.5Z",
    fill: "red"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2429_3161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 25,
    fill: "red"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoteCount);
export default __webpack_public_path__ + "static/media/vote-count.8e0c04369e82d52fed21c41dff402c0c.svg";
export { ForwardRef as ReactComponent };